<template>
    <div class="space-y-6">
        <div class="relative h-[280px]">
            <NuxtImg src="/dashboard/more-inputs.webp" class="rounded-3xl lg:h-full h-[280px] object-cover" />
            <div
                class="absolute w-full text-gray-100 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center lg:max-w-[451px] max-w-[281px]"
            >
                <div>
                    <p class="text-title-xl font-bold mb-2">Go Premium!</p>
                    <p class="text-body-lg mb-2">Please subscribe to a plan to keep generating!</p>
                </div>
            </div>
        </div>

        <div class="grid lg:grid-cols-2 grid-cols-1 items-center gap-4">
            <app-button
                variant="ghost"
                class="text-brand-300 border rounded-full order-2 lg:order-1 flex justify-center"
                @click="$emit('cancel')"
            >
                {{ $t("global_cancel") }}
            </app-button>
            <app-button
                class="text-gray-100 bg-brand-500 rounded-full order-1 lg:order-2 flex justify-center"
                @click="$emit('upgrade')"
            >
                See Plans
            </app-button>
        </div>
    </div>
</template>

<script setup lang="ts">
const { $clientPosthog } = useNuxtApp();

onMounted(() => {
    $clientPosthog?.capture("aihd_no_credit");
});
</script>
